module.exports = __webpack_public_path__ + "img/FGDI.ea77c324.svg";